import {
  GET_BRANDS,
  GET_BRANDS_LOADING,
  GET_FEATURED_BRANDS,
  GET_FEATURED_BRANDS_LOADING,
  GET_BRAND_ITEMS,
  GET_BRAND_ITEMS_LOADING,
  RESET_BRAND_ITEMS,
} from "./actionTypes";

const initialState = {
  brands: [],
  brandsLoading: false,
  featuredBrands: [],
  featuredBrandsLoading: false,
  brand: null,
  brandItems: [],
  brandItemsLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_BRANDS_LOADING:
      return { ...state, brandsLoading: action.payload };
    case GET_BRANDS:
      return { ...state, brands: action.payload };
    case GET_FEATURED_BRANDS_LOADING:
      return { ...state, featuredBrandsLoading: action.payload };
    case GET_FEATURED_BRANDS:
      return { ...state, featuredBrands: action.payload };
    case GET_BRAND_ITEMS_LOADING:
      return { ...state, brandItemsLoading: action.payload };
    case GET_BRAND_ITEMS:
      return {
        ...state,
        brand: action.payload.brand,
        brandItems: action.payload.items,
      };
    case RESET_BRAND_ITEMS:
      return { ...state, brand: null, brandItems: [] };
    default:
      return state;
  }
}
